import { Divider } from '@zorro/design-system/v2/Divider';
import { Grid } from '@zorro/web/design-system';

export const DividerRow = () => {
  return (
    <Grid.Col py={0}>
      <Divider />
    </Grid.Col>
  );
};
